import React, {Component} from "react";
import {Form, Input, Button, Select, Modal} from "antd";
import {getExclusivePlan} from "../../../modules/small/action";
const FormItem = Form.Item;
const Option = Select.Option;

const formItemLayout = {
    labelCol: {
        xs: {span: 24},
        sm: {span: 4},
    },
    wrapperCol: {
        xs: {span: 24},
        sm: {span: 20},
    },
};
const formItemLayoutWithOutLabel = {
    wrapperCol: {
        xs: {span: 24, offset: 0},
        sm: {span: 20, offset: 4},
    },
};
class PlanNameModal extends Component{

    constructor(props) {
        super(props);
        this.state = {
            plans : [],
            sensitivity: [],
            previewVisible: false,
            previewImage: '',
            destroy : this.props.destroy
        }
        this.handleSubmit = this.handleSubmit.bind(this);

    }
    componentWillMount() {
        const {planInfo} = this.props;
        const b = (JSON.stringify(planInfo) == "{}")
        if (!b){
            this.setState({
                sensitivity: this.props.planInfo ? this.props.planInfo.sensitivity : []
            })
        }


    }




    componentDidMount() {
        let {plans} = this.state;
        for (let i = 0; i < this.props.plans.length; i++) {
            plans.push(<Option key={this.props.plans[i].planId}>{this.props.plans[i].planName}</Option>)
        }

        // let _self = this;
        // this.props.form.validateFields((err, values) => {
        //     if (!err) {
        //         let {onCommit} = _self.props;
        //         let {userId,dynamicContent,circleName,DynamicStatus,dateRange} = values;
        //
        //         console.log(values)
        //
        //         onCommit && onCommit(userId,dynamicContent,circleName,DynamicStatus,dateRange);
        //     }
        // });
    }

    handleSubmit(e) {
        e.preventDefault();
        let _self = this;
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let {onCommit} = _self.props;
                let {planName} = values;
                let {modelId} = this.props;

                console.log(values)
                console.log(planName)


                onCommit && onCommit(planName,modelId);
            }
        });
    }

    onSearch(val){
        console.log('search:', val)
    }
    onChangeValue = async e => {
        console.log(e)
        const {getExclusivePlan} = this.props;
        await getExclusivePlan(e)
        console.log(this.props.planInfo)
        this.setState({
            sensitivity: this.props.planInfo ? this.props.planInfo.sensitivity : [],
            destroy : false

        })
    }
    render() {
        const {getFieldDecorator} = this.props.form;
        const {plans,sensitivity,previewVisible,previewImage,destroy} = this.state;
        const {planInfo,planName} = this.props;
        console.log(this.props)
        const keys = destroy ? [] : sensitivity;
        console.log(keys)
        const formItems = keys.map((k, index) => {
            return (<div>
                <FormItem
                    {...(index === 0 ? formItemLayout : formItemLayoutWithOutLabel)}
                    label={index === 0 ? '灵敏度方案' : ''}
                >
                    <div>
                        <FormItem style={{width: 'calc(40%)'}}>
                            {getFieldDecorator(`value[${index}]`, {
                                initialValue: k.value,
                                validateTrigger: ['onChange', 'onBlur'],
                                rules: [{
                                    required: true,
                                    whitespace: true,
                                    message: '方案名称',
                                }],
                            })(
                                <Input placeholder="请输入方案名称" disabled/>,
                            )}
                        </FormItem>
                        {k.params.map((element, e_index) => (
                            <div>
                                <Form.Item
                                    required={false}
                                    style={{display: 'inline-block', width: 'calc(40%)', marginRight: 8}}
                                >
                                    {getFieldDecorator(`params[${index}][${e_index}].key`, {
                                        initialValue: element.key,
                                        validateTrigger: ['onChange', 'onBlur'],
                                        rules: [
                                            {
                                                required: true,
                                                whitespace: true,
                                                message: "请输入属性key.",
                                            },
                                        ],
                                    })(<Input placeholder="key" disabled/>)}
                                </Form.Item>
                                <Form.Item
                                    required={false}
                                    style={{display: 'inline-block', width: 'calc(40%)', marginRight: 8}}
                                >
                                    {getFieldDecorator(`params[${index}][${e_index}].value`, {
                                        initialValue: element.value,
                                        validateTrigger: ['onChange', 'onBlur'],
                                        rules: [
                                            {
                                                required: true,
                                                whitespace: true,
                                                message: "请输入属性value.",
                                            },
                                        ],
                                    })(<Input placeholder="value" disabled/>)}
                                </Form.Item>
                                {/*{k.params.length > 1 ? (*/}
                                {/*    <Icon*/}
                                {/*        className="dynamic-delete-button"*/}
                                {/*        type="minus-circle-o"*/}
                                {/*    />*/}
                                {/*) : null}*/}
                            </div>
                        ))}


                    </div>
                </FormItem>
            </div>)
        });

        return (
            <Form onSubmit={this.handleSubmit}>
                <FormItem label="方案名" {...formItemLayout}>
                    {getFieldDecorator('planName', {
                            initialValue: planName
                        }
                    )(
                        <Select style={{width: 120}} defaultValue={planName}
                                showSearch
                                optionFilterProp="children"
                                onSearch={this.onSearch}
                                onChange={this.onChangeValue}
                        >
                            {plans}
                        </Select>
                    )}
                </FormItem>

                <FormItem
                    label="名称"
                    {...formItemLayout}
                >
                    {getFieldDecorator('name', {
                        initialValue: destroy ? "" : planInfo.name  ,

                        rules: [{required: true, message: '请填写方案名称!'}],
                    })(
                        <Input style={{width: 120}} placeholder="请填写方案名称" disabled/>,
                    )}
                </FormItem>

                <FormItem
                    label="图片"
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...formItemLayout}
                >
                    {getFieldDecorator('imageUrl', {
                        initialValue: destroy ?  "" : planInfo.imageUrl ,
                        rules: [{required: true, message: '图片未上传!'}],
                    })(
                        <img style={{ width: '50%',height :'50%' }} alt={""} src={destroy ?  null : planInfo.imageUrl+'?x-oss-process=image/resize,w_690'}/>
                    )}
                </FormItem>
                {formItems}
                {previewVisible ? <Modal visible={previewVisible} footer={null} onCancel={this.onThisCancel}>
                    <img alt="example" style={{width: '100%'}} src={previewImage}/>
                </Modal> : null}
                <FormItem>
                    <Button type="primary" htmlType="submit" style={{width: '20%'}}>
                        确认
                    </Button>
                </FormItem>


            </Form>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        ...state.models
    }
};
const mapDispatchToProps = ({
    getExclusivePlan
});

export default Form.create()(PlanNameModal);